import React, { useEffect } from 'react';
import { useA11y } from '../hooks/useA11y.js';

export function ReadingMask() {
  const { settings } = useA11y();
  const [mouseY, setMouseY] = React.useState(0);

  useEffect(() => {
    if (!settings.readingMask) return;

    let rafId = null;
    const handleMouseMove = (e) => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        setMouseY(e.clientY);
        rafId = null;
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [settings.readingMask]);

  if (!settings.readingMask) return null;

  const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800;
  const maskHeight = 120;
  const topHeight = Math.max(0, mouseY - maskHeight / 2);
  const bottomHeight = Math.max(0, viewportHeight - mouseY - maskHeight / 2);

  return (
    <>
      <div
        className="a11y-reading-mask a11y-reading-mask--top"
        style={{ height: topHeight }}
        aria-hidden="true"
      />
      <div
        className="a11y-reading-mask a11y-reading-mask--bottom"
        style={{ height: bottomHeight }}
        aria-hidden="true"
      />
    </>
  );
}

export default ReadingMask;